<template>
  <div class="p-fluid">
    <div class="card">
      <h5 class="p-text-center">Edición de empresas</h5>
      <form @submit.prevent="handleSubmit(!v$.$invalid)">
        <div class="p-field">
          <span class="p-float-label">
            <InputText
              id="name"
              v-model="v$.name.$model"
              :class="{ 'p-invalid': v$.name.$invalid && submitted }"
            />
            <label
              for="name"
              :class="{ 'p-error': v$.name.$invalid && submitted }"
              >Name*</label
            >
          </span>
          <small
            v-if="(v$.name.$invalid && submitted) || v$.name.$pending.$response"
            class="p-error"
            >{{ v$.name.required.$message.replace('Value', 'Name') }}</small
          >
        </div>

        <div class="p-field">
          <label
            for="apiUrl"
            :class="{ 'p-error': v$.apiUrl.$invalid && submitted }"
            >Api URL*</label
          >
          <InputText
            id="name"
            v-model="v$.apiUrl.$model"
            :class="{ 'p-invalid': v$.apiUrl.$invalid && submitted }"
          />
          <small
            v-if="
              (v$.apiUrl.$invalid && submitted) || v$.apiUrl.$pending.$response
            "
            class="p-error"
            >{{
              v$.apiUrl.required.$message.replace('Value', 'Api user')
            }}</small
          >
        </div>

        <div class="p-field">
          <label
            for="apiUser"
            :class="{ 'p-error': v$.apiUser.$invalid && submitted }"
            >Api User*</label
          >
          <InputText
            id="name"
            v-model="v$.apiUser.$model"
            :class="{ 'p-invalid': v$.apiUser.$invalid && submitted }"
          />
          <small
            v-if="
              (v$.apiUser.$invalid && submitted) ||
                v$.apiUser.$pending.$response
            "
            class="p-error"
            >{{
              v$.apiUser.required.$message.replace('Value', 'Api user')
            }}</small
          >
        </div>

        <div class="p-field">
          <label
            for="apiPassword"
            :class="{ 'p-error': v$.apiPassword.$invalid && submitted }"
            >Api Password*</label
          >
          <Password
            id="apiPassword"
            v-model="v$.apiPassword.$model"
            toggleMask="true"
            :class="{ 'p-invalid': v$.apiPassword.$invalid && submitted }"
          />
          <small
            v-if="
              (v$.apiPassword.$invalid && submitted) ||
                v$.apiPassword.$pending.$response
            "
            class="p-error"
            >{{
              v$.apiPassword.required.$message.replace('Value', 'Passowrd')
            }}</small
          >
        </div>

        <div class="p-field-checkbox">
          <InputSwitch id="active" v-model="v$.active.$model" />
          <label class="p-label" for="active">Activa</label>
        </div>

        <div class="p-d-flex p-jc-center">
          <div class="p-mr-2"><Button type="submit" label="Guardar" /></div>
          <router-link to="/empresas">
            <div class="p-mr-2"><Button type="button" label="Cancel" /></div>
          </router-link>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { apiGet, apiPut } from '../../helpers/rest-api';
import useVuelidate from '@vuelidate/core';
import { required } from '@vuelidate/validators';

export default {
  setup() {
    return { v$: useVuelidate() };
  },
  data() {
    return {
      name: '',
      active: false,
      logo: '',
      id: '',
      submitted: false,
      apiUser: '',
      apiPassword: '',
      apiUrl: false,
    };
  },
  validations() {
    return {
      name: {
        required,
      },
      active: {
        required: false,
      },
      apiUrl: {
        required: false,
      },
      apiUser: {
        required: true,
      },
      apiPassword: {
        required: false,
      },
    };
  },
  mounted() {
    this.getId(this.$router.currentRoute.value.params.id);
  },

  methods: {
    getId(id) {
      apiGet(`empresa/${id}`).then(
        (response) => (
          (this.name = response.data.name),
          (this.id = response.data.id),
          (this.active = response.data.active),
          (this.apiUser = response.data.apiUser),
          (this.apiPassword = response.data.apiPassword),
          (this.apiUrl = response.data.apiUrl)
        )
      );
    },

    handleSubmit() {
      this.submitted = true;
      const { name, active, id, apiUser, apiPassword, apiUrl } = this;
      console.log(active, name);
      apiPut(
        `empresa/${id}`,
        JSON.stringify({
          name,
          active,
          logo: '',
          apiUser,
          apiPassword,
          apiUrl,
        })
      ).then(() => this.$router.push('/empresas'));
    },
  },
};
</script>
